"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _H = _interopRequireDefault(require("../../typography/headings/H3"));

var _styles = require("./styles");

var _SpannerIcon = _interopRequireDefault(require("../../icons/standard-icons/SpannerIcon"));

var _CircleIcon = _interopRequireDefault(require("../../icons/circle-icon/CircleIcon"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * ErrorCard Component
 *
 * This component displays the policy details including title, number and accordion of further info
 *
 */
const ErrorCard = ({
  children,
  action,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledErrorCard, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircleIcon.default, {
      error: true,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SpannerIcon.default, {}),
      size: 80,
      mb: "40px"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_H.default, {
    m: "0",
    fontSize: {
      _: 5,
      lg: 6
    },
    children: children
  }), action && action.route && action.label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinkButton, {
    primary: true,
    to: action.route,
    children: action.label
  })]
});

ErrorCard.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  action: _propTypes.default.shape({
    route: _propTypes.default.string,
    label: _propTypes.default.string
  })
};
var _default = ErrorCard;
exports.default = _default;